export class Company {
  public name: string;
  public id: string;
  public createdAt: string;
  public updatedAt: string;
  public city: string;
  public country: string;
  public postalCode: string;
  public addressLine1: string;
  public addressLine2: string;
  public companyTaxId: string;
  public agencyOwnerTenantId?: string;
  public agencyOwnerTenantName?: string;

  constructor(response: any) {
    const address = response?.address || {};
    this.name = response.name;
    this.city = response.city ?? address.city;
    this.country = response.country ?? address.country;
    this.postalCode = response.postalCode ?? address.postalCode;
    this.addressLine1 = response.addressLine1 ?? address.addressLine1;
    this.addressLine2 = response.addressLine2 ?? address.addressLine2;
    this.id = response.id ?? response._id;
    this.createdAt = response.createdAt;
    this.updatedAt = response.updatedAt;
    this.companyTaxId = response.companyTaxId;
    this.agencyOwnerTenantId = response.agencyOwnerTenantId;
    this.agencyOwnerTenantName = response.agencyOwnerTenantName;
  }
}
